import { render, staticRenderFns } from "./ReplacedStandardCard.vue?vue&type=template&id=4aba5d7c&scoped=true"
import script from "./ReplacedStandardCard.vue?vue&type=script&lang=js"
export * from "./ReplacedStandardCard.vue?vue&type=script&lang=js"
import style0 from "./ReplacedStandardCard.vue?vue&type=style&index=0&id=4aba5d7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aba5d7c",
  null
  
)

export default component.exports